import { Divider, Flex, Input, Radio, Space } from "antd"
import { OrderInfoInterface } from "../../types"
import { StripeForm } from "./StripeForm"

import { useTheme } from "styled-components"
import { GrayLabel, LabeledBox } from "../GeneralComponents"

export const Payment = (props: {
    orderInfo: OrderInfoInterface
    setOrderInfo: React.Dispatch<React.SetStateAction<OrderInfoInterface>>
    totalPrice: { price: number; unit: string; country: string }
}): JSX.Element => {
    // const [paymentMethod, setPaymentMethod] = useState<string>("PO")
    const theme = useTheme()
    // console.log('total price:', props.totalPrice)
    return (
        <div>
            <LabeledBox title="Payment Information" border>
                {/* {props.totalPrice?.price ?? 1111} */}
                {(props.totalPrice?.price ?? 0) > 0 ?
                    (<div>
                        <div>
                            <Radio.Group
                                onChange={(e) => {
                                    // setPaymentMethod(e.target.value)
                            props.setOrderInfo({
                                ...props.orderInfo,
                                paymentInfo: { ...props.orderInfo.paymentInfo, method: e.target.value },
                            })
                        }}
                        value={props.orderInfo.paymentInfo?.method}
                    >
                        {" "}
                        <Space direction="vertical">
                            <Radio value={"PO"}>
                                <div style={{ width: "10em" }}>
                                    <span
                                        className="material-symbols-outlined"
                                        style={{
                                            verticalAlign: "middle",
                                            fontSize: "1rem",
                                            color:
                                                props.orderInfo.paymentInfo?.method === "PO"
                                                    ? theme.primary
                                                    : theme.forth,
                                        }}
                                    >
                                        order_approve
                                    </span>
                                    <span
                                        style={{
                                            verticalAlign: "middle",
                                            marginLeft: "1rem",
                                            fontWeight:
                                                props.orderInfo.paymentInfo?.method === "PO" ? "bold" : "normal",
                                        }}
                                    >
                                        PO
                                    </span>
                                </div>
                            </Radio>
                            <Radio value={"credit card"}>
                                <div style={{ width: "10em" }}>
                                    <span
                                        className="material-symbols-outlined"
                                        style={{
                                            verticalAlign: "middle",
                                            fontSize: "1rem",
                                            color:
                                                props.orderInfo.paymentInfo?.method === "credit card"
                                                    ? theme.primary
                                                    : theme.forth,
                                        }}
                                    >
                                        credit_card
                                    </span>
                                    <span
                                        style={{
                                            verticalAlign: "middle",
                                            marginLeft: "1em",
                                            fontWeight:
                                                props.orderInfo.paymentInfo?.method === "credit card"
                                                    ? "bold"
                                                    : "normal",
                                        }}
                                    >
                                        Credit Card
                                    </span>
                                </div>
                            </Radio>
                        </Space>
                    </Radio.Group>
                </div>
                <Divider />
                <div
                    style={{
                        padding: "10px",
                        minHeight: "8em",
                    }}
                >
                    <Flex justify="center">
                        {props.orderInfo.paymentInfo?.method === "PO" && (
                            <div style={{ width: "100%" }} className={"fade-in"}>
                                <Flex vertical>
                                    <GrayLabel>Please enter the PO number:</GrayLabel>
                                    <div style={{ width: "100%" }}>
                                        <div style={{ maxWidth: "20em" }}>
                                            <Input
                                                type="text"
                                                id="po"
                                                // style={{ maxWidth: "30em" }}
                                                value={props.orderInfo.paymentInfo.PoNumber}
                                                onChange={(e) => {
                                                    props.setOrderInfo({
                                                        ...props.orderInfo,
                                                        paymentInfo: {
                                                            ...props.orderInfo.paymentInfo,
                                                            PoNumber: e.target.value,
                                                        },
                                                    })
                                                }}
                                                size="large"
                                                // maxLength={60}
                                                name="phone"
                                            />
                                        </div>
                                    </div>
                                </Flex>
                            </div>
                        )}
                        {props.orderInfo.paymentInfo?.method === "credit card" && (
                            <div
                                style={{
                                    width: "100%",
                                    padding: "10px",
                                    marginBottom: "2em",
                                }}
                                className={"fade-in"}
                            >
                                <StripeForm />
                            </div>
                        )}
                    </Flex>
                </div></div>):(<div>No payment required.</div>)}
            </LabeledBox>
        </div>
    )
}
